import modalActions from "actions/modal";
import profileActions from "actions/profile";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Monitoring from "./index";

const mapStateToProps = (state) => ({
    organization: state.profile.organization,
    profile: state.profile.profile,
    roles: state.profile.roles,
});

const mapDispatchToProps = (dispatch) => ({
    modal: (params) => dispatch(modalActions.open(params)),
    getOrg: () => dispatch(profileActions.getOrg()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Monitoring));
